import React from "react";

import { Grid } from "@material-ui/core";

import { InputText } from "../../../../components";
import InputLookupMembers from "../../../basics/lookup/members";

export default function ArquivosRelatorioCaixa({ atributos, setAtributos }) {
    return (
        <>
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <InputLookupMembers
                        roleMember="branch"
                        label="Estabelecimento"
                        value={atributos.branch}
                        onChangeValue={(data) =>
                            setAtributos({
                                ...atributos,
                                branch: {
                                    id: data.id,
                                    document: data.document,
                                    name: data.name,
                                    type_member: data.type_member,
                                    state_id: data.state_id,
                                    city_name: data.city_name,
                                    city_id: data.city_id,
                                },
                            })
                        }
                        required={true}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={1} style={{ paddingTop: "8px" }}>
                <Grid item xs={2}>
                    <InputText
                        label="Conta Débito"
                        value={atributos?.conta_debito || ""}
                        onChangeValue={(e) => setAtributos({ ...atributos, conta_debito: e.target.value })}
                    />
                </Grid>
                <Grid item xs={2}>
                    <InputText
                        label="Conta Crédito"
                        value={atributos?.conta_credito || ""}
                        onChangeValue={(e) => setAtributos({ ...atributos, conta_credito: e.target.value })}
                    />
                </Grid>
                <Grid item xs={2}>
                    <InputText
                        label="Histórico"
                        value={atributos?.historico || ""}
                        onChangeValue={(e) => setAtributos({ ...atributos, historico: e.target.value })}
                    />
                </Grid>
            </Grid>
        </>
    );
}

export function ValidadeArquivosRelatorioCaixa(data) {
    const message = [];

    if (!data?.branch?.id) {
        message.push("Informe o estabelecimento para geração.");
    }

    if (!data?.conta_debito) {
        message.push("Informe a conta débito.");
    }

    if (!data?.conta_credito) {
        message.push("Informe a conta crédito.");
    }

    if (!data?.historico) {
        message.push("Informe o histórico.");
    }

    return {
        status: message.length === 0,
        data: {
            estabelecimento: data?.branch?.id,
            cnpj: data?.branch?.document,
            uf: data?.branch?.state_id,
            cidade: data?.branch?.city_id,
            conta_debito: data?.conta_debito,
            conta_credito: data?.conta_credito,
            historico: data?.historico,
        },
        message,
    };
}
